import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import {
  getToken,
  setToken,
  removeToken,
  hasToken,
  setRefreshToken,
  removeRefreshToken,
} from '../../util/tokenStorage';

import { api } from '../../api/api';
import store from '../../../store.js';

export const authenticate = createAsyncThunk(
  'login/authenticate',
  async (_, thunkApi) => {
    const login = store.getState().login;
    try {
      const response = await api.auth(login.username, login.password);
      return response;
    } catch (error) {
      const defaultError = {
        detail: 'An error occured. Please try again.',
      };
      return thunkApi.rejectWithValue({
        error: error.response?.data || defaultError,
      });
    }
  },
);

export const fetchLoginConfig = createAsyncThunk(
  'login/fetchLoginConfig',
  async (_, thunkApi) => {
    try {
      return await api.loginConfigs();
    } catch {
      return thunkApi.rejectWithValue({});
    }
  },
);

export const initialState = {
  token: '',
  username: '',
  password: '',
  forgotPassword: false,
  authenticated: false,
  loginConfig: {
    configs: [],
    configLoaded: false,
  },
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    startUp(state, action) {
      // Bootstraps authentication status from localStorage
      if (hasToken()) {
        state.authenticated = true;
      }
    },
    setUsername(state, action) {
      state.username = action.payload;
    },
    setPassword(state, action) {
      state.password = action.payload;
    },
    toggleForgotPassword(state, action) {
      state.forgotPassword = !state.forgotPassword;
    },
    logout(state, action) {
      removeToken();
      removeRefreshToken();
      state.authenticated = false;
    },
    setAuthenticated(state) {
      state.authenticated = true;
    },
  },
  extraReducers: {
    [authenticate.fulfilled]: (state, action) => {
      state.username = '';
      state.password = '';
      setToken(action.payload.token);
      setRefreshToken(action.payload.refresh_token);
      state.authenticated = true;
    },
    [authenticate.rejected]: (state, action) => {},
    [fetchLoginConfig.fulfilled]: (state, action) => {
      state.loginConfig = { configs: action.payload, configLoaded: true };
    },
    [fetchLoginConfig.rejected]: (state) => {
      state.loginConfig.configLoaded = true;
    },
  },
});

export const {
  setUsername,
  setPassword,
  logout,
  toggleForgotPassword,
  startUp,
  setAuthenticated,
} = loginSlice.actions;

export default loginSlice.reducer;
